import { LinearGradient as ExpoLinearGradient } from 'expo-linear-gradient';
import React, { FunctionComponent } from 'react';
import { Platform, StyleProp } from 'react-native';
import { LinearGradient as ReactNativeLinearGradient } from 'react-native-linear-gradient';

interface IProps {
  webClassName: string;
  style: StyleProp<any>;
  colors: string[];
  start?: { x: number, y: number };
  end?: { x: number, y: number };
}

export const LinearGradient: FunctionComponent<IProps> = ({
  style,
  webClassName,
  colors,
  ...props
}) => {
  if (Platform.OS === 'web') {
    return <div className={webClassName} />;
  }
  if (Platform.OS === 'ios') {
    // iOS 17 crashes on ExpoLinearGradient, Android crashes on ReactNativeLinearGradient
    return (
      <ReactNativeLinearGradient
        colors={colors}
        style={style}
        {...props}
      />
    );
  }

  return (
    <ExpoLinearGradient
      colors={colors}
      style={style}
      {...props}
    />
  );
};
